export function getShortFieldName(field: string) {
  return field.replace('formattedData.', '')
}
